import commonApi from "./apiList/commonApi";
const apiList = {
  ...commonApi,
};
export default apiList;
